
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { equals, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { RouterModule_trySeparateLast, RouterModule_encodeQueryString, RouterModule_nav, RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { append as append_1, exists, tryHead, take, length, choose, isEmpty, toArray, filter, map, empty as empty_1, singleton, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { concat, join, printf, toText } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { toArray as toArray_1, empty, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { UserDetails, VehicleDetails, StudentDetails, SchoolClassDetails, ConstructionSiteDetails, ProjectDetails, SubcontractorDetails, RoomDetails, ExternalPersonDetails, EmployeeDetails } from "./ReceiverDetailWidget.js";
import { Msg } from "../Types.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { MultiAssignModalSheet, PredefinedQuantityType } from "../../Widgets/Modals/MultiAssignModal.js";
import { MultiUnassignModalSheet } from "../../Widgets/Modals/MultiUnassignModal.js";
import { MultiSetLostStateModalSheet } from "../../Widgets/Modals/MultiSetLostStateModal.js";
import { MultiUpdatePlannedReturnDateModalSheet } from "../../Widgets/Modals/MultiPlannedReturnDateModal.js";
import { TableControl$1, Table } from "../../Widgets/Table/Table.js";
import { ColumnDefinition$1, CellContent, OnTableRowClick$1 } from "../../Widgets/Table/Types.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { UserId as UserId_1, ConsumableId, ConsumableId__get_unwrap, SetId, ToolId, LabelId } from "../../Shared/Shared.js";
import { Label as Label_1 } from "../../Shared/Category.js";
import { map as map_1, defaultArgWith, unwrap, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import Following from "../../../public/assets/icons/Following.svg";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import Shipment_Search from "../../../public/assets/icons/Shipment_Search.svg";
import Shipment_Return from "../../../public/assets/icons/Shipment_Return.svg";
import { roleToString, unwrapToolId } from "../../Shared/Helper.js";
import { Button } from "../../Components/Button.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { Table_customPropertyColumnDefinitions, Table_customPropertyValueDtoColumnDefinitions } from "../../Widgets/CustomProperties.js";
import { Helper_unitToTranslationKey } from "../../Shared/Consumable.js";
import { StoragePermissionType__ToI18nString } from "../../Shared/Receiver.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { AddVisibleReceiverToUserModal } from "./Modals/AddVisibleReceiverModal.js";
import Shipment_Add from "../../../public/assets/icons/Shipment_Add.svg";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { DocumentTable } from "../../Widgets/Table/DocumentTable.js";
import { UploadType as UploadType_2 } from "../../Widgets/Dialogs/FileUploadDialog.js";
import { ReservationTable } from "../../Widgets/Table/PlanningTable.js";
import { QrCodeTable } from "../../Widgets/Table/QrCodeTable.js";
import { DetailViewHeader } from "../../Widgets/DetailViewHeader.js";
import { ReceiverTypeName, Helper_receiverTypeNameToString } from "../../Shared/User.js";
import { AreaAnchorMenu } from "../../Widgets/AnchorMenu.js";
import { WarningAlert } from "../../Components/Alert.js";
import { BlockHeader } from "../../Components/Text.js";
import { TableContainer } from "../../Widgets/Container.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, initToolBox } from "../State.js";
import { isWhoHasWhatOnboardingReceiverDetailPhase, getQueryParams, withoutOnboardingTourQueryParams } from "../../Common.js";
import { TourGuideLocale, TourStep, TourGuide } from "../../Components/TourGuide.js";
import { Skeleton } from "../../Components/Skeleton.js";

export function DetailBtn(row) {
    let elems;
    const patternInput = useTranslation();
    return reactElement("a", createObj(ofArray([["href", RouterModule_encodeParts(singleton(RouterModule_encodeParts(ofArray(["receivers", row.UserId]), 1)), 1)], (elems = [reactElement("i", {
        className: "fas fa-eye",
    }), reactElement("span", {
        className: "url-text",
        children: patternInput[0]("general.display"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function tabElement(text, active, tabName, _arg) {
    let elems;
    return reactElement("li", createObj(ofArray([["className", "nav-item"], (elems = [reactElement("a", {
        id: toText(printf("%s-tab"))(tabName),
        className: join(" ", toList(delay(() => append(singleton_1("nav-link"), delay(() => (active ? singleton_1("active") : empty())))))),
        "data-toggle": "tab",
        children: text,
        href: toText(printf("#%s"))(tabName),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function ToolboxHeaderSection(props) {
    let elems_1, elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-shrink-0", "flex-col", "mb-3", "bg-white", "rounded", "px-12", "py-9"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex"])], (elems = toList(delay(() => {
        const matchValue = props.Receiver.ReceiverType;
        return (matchValue.tag === 1) ? singleton_1(createElement(EmployeeDetails, {
            AccountSettings: props.AccountSettings,
            Customer: props.Customer,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            Locations: props.Locations,
            OnDeleteImage: () => {
                props.Dispatch(new Msg(0, []));
            },
            OnUploadImage: (file_1) => {
                props.Dispatch(new Msg(3, [file_1]));
            },
            PropertyConfigurations: props.PropertyConfigurations,
            ReceiverId: props.Receiver.Id,
            ToolBox: props.Toolbox,
            TriggerRerender: props.TriggerRerender,
            UserData: props.UserData,
        })) : ((matchValue.tag === 2) ? singleton_1(createElement(ExternalPersonDetails, {
            AccountSettings: props.AccountSettings,
            Customer: props.Customer,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            OnDeleteImage: () => {
                props.Dispatch(new Msg(0, []));
            },
            OnUploadImage: (file_2) => {
                props.Dispatch(new Msg(3, [file_2]));
            },
            PropertyConfigurations: props.PropertyConfigurations,
            ReceiverId: props.Receiver.Id,
            ToolBox: props.Toolbox,
            TriggerRerender: props.TriggerRerender,
            UserData: props.UserData,
        })) : ((matchValue.tag === 4) ? singleton_1(createElement(RoomDetails, {
            AccountSettings: props.AccountSettings,
            Customer: props.Customer,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            Locations: props.Locations,
            OnDeleteImage: () => {
                props.Dispatch(new Msg(0, []));
            },
            OnUploadImage: (file_3) => {
                props.Dispatch(new Msg(3, [file_3]));
            },
            PropertyConfigurations: props.PropertyConfigurations,
            ReceiverId: props.Receiver.Id,
            ToolBox: props.Toolbox,
            TriggerRerender: props.TriggerRerender,
            UserData: props.UserData,
        })) : ((matchValue.tag === 3) ? singleton_1(createElement(SubcontractorDetails, {
            AccountSettings: props.AccountSettings,
            Customer: props.Customer,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            OnDeleteImage: () => {
                props.Dispatch(new Msg(0, []));
            },
            OnUploadImage: (file_4) => {
                props.Dispatch(new Msg(3, [file_4]));
            },
            PropertyConfigurations: props.PropertyConfigurations,
            ReceiverId: props.Receiver.Id,
            ToolBox: props.Toolbox,
            TriggerRerender: props.TriggerRerender,
            UserData: props.UserData,
        })) : ((matchValue.tag === 5) ? singleton_1(createElement(ProjectDetails, {
            AccountSettings: props.AccountSettings,
            Customer: props.Customer,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            OnDeleteImage: () => {
                props.Dispatch(new Msg(0, []));
            },
            OnUploadImage: (file_5) => {
                props.Dispatch(new Msg(3, [file_5]));
            },
            PropertyConfigurations: props.PropertyConfigurations,
            ReceiverId: props.Receiver.Id,
            ToolBox: props.Toolbox,
            TriggerRerender: props.TriggerRerender,
            UserData: props.UserData,
        })) : ((matchValue.tag === 6) ? singleton_1(createElement(ConstructionSiteDetails, {
            AccountSettings: props.AccountSettings,
            Customer: props.Customer,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            OnDeleteImage: () => {
                props.Dispatch(new Msg(0, []));
            },
            OnUploadImage: (file_6) => {
                props.Dispatch(new Msg(3, [file_6]));
            },
            PropertyConfigurations: props.PropertyConfigurations,
            ReceiverId: props.Receiver.Id,
            ToolBox: props.Toolbox,
            TriggerRerender: props.TriggerRerender,
            UserData: props.UserData,
        })) : ((matchValue.tag === 8) ? singleton_1(createElement(SchoolClassDetails, {
            AccountSettings: props.AccountSettings,
            Customer: props.Customer,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            OnDeleteImage: () => {
                props.Dispatch(new Msg(0, []));
            },
            OnUploadImage: (file_7) => {
                props.Dispatch(new Msg(3, [file_7]));
            },
            PropertyConfigurations: props.PropertyConfigurations,
            ReceiverId: props.Receiver.Id,
            ToolBox: props.Toolbox,
            TriggerRerender: props.TriggerRerender,
            UserData: props.UserData,
        })) : ((matchValue.tag === 7) ? singleton_1(createElement(StudentDetails, {
            AccountSettings: props.AccountSettings,
            Customer: props.Customer,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            OnDeleteImage: () => {
                props.Dispatch(new Msg(0, []));
            },
            OnUploadImage: (file_8) => {
                props.Dispatch(new Msg(3, [file_8]));
            },
            PropertyConfigurations: props.PropertyConfigurations,
            ReceiverId: props.Receiver.Id,
            ToolBox: props.Toolbox,
            TriggerRerender: props.TriggerRerender,
            UserData: props.UserData,
        })) : ((matchValue.tag === 9) ? singleton_1(createElement(VehicleDetails, {
            AccountSettings: props.AccountSettings,
            Customer: props.Customer,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            Locations: props.Locations,
            OnDeleteImage: () => {
                props.Dispatch(new Msg(0, []));
            },
            OnUploadImage: (file_9) => {
                props.Dispatch(new Msg(3, [file_9]));
            },
            PropertyConfigurations: props.PropertyConfigurations,
            ReceiverId: props.Receiver.Id,
            ToolBox: props.Toolbox,
            TriggerRerender: props.TriggerRerender,
            UserData: props.UserData,
        })) : ((matchValue.tag === 10) ? singleton_1(defaultOf()) : singleton_1(createElement(UserDetails, {
            AccountSettings: props.AccountSettings,
            Customer: props.Customer,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            Locations: props.Locations,
            OnDeleteImage: () => {
                props.Dispatch(new Msg(0, []));
            },
            OnUploadImage: (file) => {
                props.Dispatch(new Msg(3, [file]));
            },
            PropertyConfigurations: props.PropertyConfigurations,
            ReceiverId: props.Receiver.Id,
            ToolBox: props.Toolbox,
            TriggerRerender: props.TriggerRerender,
            UserData: props.UserData,
        })))))))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ToolboxToolsSection(props) {
    let elems, TableRows, Options;
    const patternInput = reactApi.useState([false, [empty_1(), empty_1()]]);
    const setIsAssignModalSheetOpen = patternInput[1];
    const isAssignModalSheetOpen = patternInput[0];
    const patternInput_1 = reactApi.useState([false, [empty_1(), empty_1()]]);
    const setIsUnassignModalSheetOpen = patternInput_1[1];
    const isUnassignModalSheetOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState([false, [empty_1(), empty_1()]]);
    const setIsSetLostStateModalSheetOpen = patternInput_2[1];
    const isSetLostStateModalSheetOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState([false, [empty_1(), empty_1()]]);
    const setIsPlannedReturnDateModalSheetOpen = patternInput_3[1];
    const isPlannedReturnDateModalSheetOpen = patternInput_3[0];
    const predefinedQuantity = map((row_1) => ({
        Id: row_1.ToolId,
        PredefinedQuantityType: new PredefinedQuantityType(1, [row_1.Quantity]),
    }), filter((row) => !row.IsTool, props.ToolRows));
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(MultiAssignModalSheet, {
        AssignProps: {
            ConsumableIds: empty_1(),
            SetIds: isAssignModalSheetOpen[1][1],
            ToolIds: isAssignModalSheetOpen[1][0],
        },
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: isAssignModalSheetOpen[0],
        OnClose: () => {
            setIsAssignModalSheetOpen([false, [empty_1(), empty_1()]]);
        },
        PredefinedQuantities: predefinedQuantity,
        SenderId: props.ToolBox.Receiver.Id,
        SuccessCallback: () => {
            props.Dispatch(new Msg(27, []));
        },
        UserData: props.UserData,
    }), createElement(MultiUnassignModalSheet, {
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: isUnassignModalSheetOpen[0],
        OnClose: () => {
            setIsUnassignModalSheetOpen([false, [empty_1(), empty_1()]]);
        },
        SenderId: props.ToolBox.Receiver.Id,
        SuccessCallback: () => {
            props.Dispatch(new Msg(27, []));
        },
        UnassignProps: {
            ConsumableIds: empty_1(),
            SetIds: isUnassignModalSheetOpen[1][1],
            ToolIds: isUnassignModalSheetOpen[1][0],
        },
        UserData: props.UserData,
    }), createElement(MultiSetLostStateModalSheet, {
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: isSetLostStateModalSheetOpen[0],
        OnClose: () => {
            setIsSetLostStateModalSheetOpen([false, [empty_1(), empty_1()]]);
        },
        Props: {
            SetIds: isSetLostStateModalSheetOpen[1][1],
            ToolIds: isSetLostStateModalSheetOpen[1][0],
        },
        SenderId: props.ToolBox.Receiver.Id,
        SuccessCallback: () => {
            props.Dispatch(new Msg(27, []));
        },
        UserData: props.UserData,
    }), createElement(MultiUpdatePlannedReturnDateModalSheet, {
        IsOpen: isPlannedReturnDateModalSheetOpen[0],
        OnClose: () => {
            setIsPlannedReturnDateModalSheetOpen([false, [empty_1(), empty_1()]]);
        },
        PlannedReturnDateProps: {
            SetIds: isPlannedReturnDateModalSheetOpen[1][1],
            ToolIds: isPlannedReturnDateModalSheetOpen[1][0],
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(27, []));
        },
        UserData: props.UserData,
    }), createElement(Table, (TableRows = toArray(props.ToolRows), (Options = {
        BorderStyle: "row",
        CSVDownload: true,
        ConfigurableColumns: true,
        CustomTableFilters: false,
        DefaultSortColumn: ["manufacturer", "asc"],
        Fullscreen: false,
        GlobalSearch: false,
        OnRowClick: new OnTableRowClick$1(1, [(row_15) => {
            const matchValue_5 = row_15.IsSet;
            return row_15.IsTool ? (matchValue_5 ? RouterModule_encodeParts(ofArray(["receivers", props.ToolBox.Receiver.Id]), 1) : RouterModule_encodeParts(ofArray(["tools", row_15.ToolId]), 1)) : (matchValue_5 ? RouterModule_encodeParts(ofArray(["sets", row_15.ToolId]), 1) : RouterModule_encodeParts(ofArray(["toolswithquantity", row_15.ToolId]), 1));
        }]),
        RowSelection: "multiRow",
        SaveTableConfiguration: true,
    }, {
        ColumnDefinitions: toArray_1(delay(() => append((props.AccountSettings.InspectionsEnabled && isFeatureEnabled(new Feature(21, []))) ? singleton_1(new ColumnDefinition$1("inspectionStatus", "", t("toolbox.inspection_status"), (row_2) => {
            const status = row_2.InspectionStatus;
            return (status == null) ? (new CellContent(0, [""])) : ((status.tag === 1) ? (new CellContent(3, [singleton(new Label_1(new LabelId("00000000-0000-0000-0000-000000000000"), t("toolbox.inspection_status_expired"), "#fd7e14", true, undefined))])) : ((status.tag === 2) ? (new CellContent(3, [singleton(new Label_1(new LabelId("00000000-0000-0000-0000-000000000000"), t("toolbox.inspection_status_failed"), "#dc3545", true, undefined))])) : ((status.tag === 3) ? (new CellContent(3, [singleton(new Label_1(new LabelId("00000000-0000-0000-0000-000000000000"), t("toolbox.inspection_status_never_inspected"), "#dc3545", true, undefined))])) : (new CellContent(3, [singleton(new Label_1(new LabelId("00000000-0000-0000-0000-000000000000"), t("toolbox.inspection_status_ok"), "#28a745", true, undefined))])))));
        }, "select", "text")) : empty(), delay(() => append(singleton_1(new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_3) => (new CellContent(0, [row_3.Manufacturer])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("model", "", t("tool.model"), (row_4) => (new CellContent(0, [row_4.Model])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_5) => (new CellContent(0, [row_5.SerialNumber])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_6) => (new CellContent(0, [row_6.InventoryNumber])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("displayName", "", t("tool.displayname"), (row_7) => (new CellContent(0, [row_7.DisplayName])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("qrCodeIds", "", t("general.qr_code"), (row_8) => (new CellContent(0, [row_8.QRCodeIds])), "text", "text")), delay(() => append((props.State.Customer.tag === 1) ? singleton_1(new ColumnDefinition$1("comment", "", t("general.comment"), (row_9) => (new CellContent(0, [row_9.Comment])), "text", "text")) : (empty()), delay(() => append((props.State.Customer.tag === 1) ? singleton_1(new ColumnDefinition$1("checkNumber", "", t("tool.prinzing.check_number"), (row_10) => (new CellContent(0, [defaultArg(row_10.CheckNumber, "")])), "text", "text")) : (empty()), delay(() => {
            let matchValue_3;
            return append((props.State.Customer.tag === 1) ? ((matchValue_3 = props.UserData.Role, (matchValue_3 === "toolManager") ? singleton_1(new ColumnDefinition$1("priceAsString", "", t("general.purchase_price"), (row_11) => (new CellContent(0, [row_11.PriceAsString])), "text", "text")) : ((matchValue_3 === "system") ? singleton_1(new ColumnDefinition$1("priceAsString", "", t("general.purchase_price"), (row_11) => (new CellContent(0, [row_11.PriceAsString])), "text", "text")) : ((matchValue_3 === "user") ? (empty()) : singleton_1(new ColumnDefinition$1("priceAsString", "", t("general.purchase_price"), (row_11) => (new CellContent(0, [row_11.PriceAsString])), "text", "text")))))) : (empty()), delay(() => append(singleton_1(new ColumnDefinition$1("quantityAsString", "", t("general.quantity"), (row_12) => (new CellContent(0, [row_12.QuantityAsString])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("rentDate", "", t("general.borrowed_on"), (row_13) => (new CellContent(7, [row_13.RentDate])), "text", "dateTime")), delay(() => singleton_1(new ColumnDefinition$1("returnDate", "", t("general.planned_return_on"), (row_14) => (new CellContent(6, [row_14.ReturnDate])), "text", "date"))))))));
        })))))))))))))))))))),
        Controls: toList(delay(() => {
            let matchValue_7;
            return append(!props.ToolBox.Receiver.IsArchived ? ((matchValue_7 = props.UserData.Role, (matchValue_7 === "toolManager") ? singleton_1(new TableControl$1(t("general.assign"), Following(), (selectedTools) => {
                if (isEmpty(selectedTools)) {
                }
                else {
                    setIsAssignModalSheetOpen([true, [choose((selectedTool) => {
                        const matchValue_9 = selectedTool.IsSet;
                        let matchResult;
                        if (selectedTool.IsTool) {
                            if (matchValue_9) {
                                matchResult = 1;
                            }
                            else {
                                matchResult = 0;
                            }
                        }
                        else if (matchValue_9) {
                            matchResult = 1;
                        }
                        else {
                            matchResult = 0;
                        }
                        switch (matchResult) {
                            case 0:
                                return new ToolId(parse(selectedTool.ToolId));
                            default:
                                return undefined;
                        }
                    }, selectedTools), choose((selectedTool_1) => {
                        const matchValue_12 = selectedTool_1.IsSet;
                        let matchResult_1;
                        if (selectedTool_1.IsTool) {
                            if (matchValue_12) {
                                matchResult_1 = 1;
                            }
                            else {
                                matchResult_1 = 1;
                            }
                        }
                        else if (matchValue_12) {
                            matchResult_1 = 0;
                        }
                        else {
                            matchResult_1 = 1;
                        }
                        switch (matchResult_1) {
                            case 0:
                                return new SetId(parse(selectedTool_1.ToolId));
                            default:
                                return undefined;
                        }
                    }, selectedTools)]]);
                }
            }, true, false, "")) : ((matchValue_7 === "system") ? singleton_1(new TableControl$1(t("general.assign"), Following(), (selectedTools) => {
                if (isEmpty(selectedTools)) {
                }
                else {
                    setIsAssignModalSheetOpen([true, [choose((selectedTool) => {
                        const matchValue_9 = selectedTool.IsSet;
                        let matchResult_2;
                        if (selectedTool.IsTool) {
                            if (matchValue_9) {
                                matchResult_2 = 1;
                            }
                            else {
                                matchResult_2 = 0;
                            }
                        }
                        else if (matchValue_9) {
                            matchResult_2 = 1;
                        }
                        else {
                            matchResult_2 = 0;
                        }
                        switch (matchResult_2) {
                            case 0:
                                return new ToolId(parse(selectedTool.ToolId));
                            default:
                                return undefined;
                        }
                    }, selectedTools), choose((selectedTool_1) => {
                        const matchValue_12 = selectedTool_1.IsSet;
                        let matchResult_3;
                        if (selectedTool_1.IsTool) {
                            if (matchValue_12) {
                                matchResult_3 = 1;
                            }
                            else {
                                matchResult_3 = 1;
                            }
                        }
                        else if (matchValue_12) {
                            matchResult_3 = 0;
                        }
                        else {
                            matchResult_3 = 1;
                        }
                        switch (matchResult_3) {
                            case 0:
                                return new SetId(parse(selectedTool_1.ToolId));
                            default:
                                return undefined;
                        }
                    }, selectedTools)]]);
                }
            }, true, false, "")) : ((matchValue_7 === "user") ? (empty()) : singleton_1(new TableControl$1(t("general.assign"), Following(), (selectedTools) => {
                if (isEmpty(selectedTools)) {
                }
                else {
                    setIsAssignModalSheetOpen([true, [choose((selectedTool) => {
                        const matchValue_9 = selectedTool.IsSet;
                        let matchResult_4;
                        if (selectedTool.IsTool) {
                            if (matchValue_9) {
                                matchResult_4 = 1;
                            }
                            else {
                                matchResult_4 = 0;
                            }
                        }
                        else if (matchValue_9) {
                            matchResult_4 = 1;
                        }
                        else {
                            matchResult_4 = 0;
                        }
                        switch (matchResult_4) {
                            case 0:
                                return new ToolId(parse(selectedTool.ToolId));
                            default:
                                return undefined;
                        }
                    }, selectedTools), choose((selectedTool_1) => {
                        const matchValue_12 = selectedTool_1.IsSet;
                        let matchResult_5;
                        if (selectedTool_1.IsTool) {
                            if (matchValue_12) {
                                matchResult_5 = 1;
                            }
                            else {
                                matchResult_5 = 1;
                            }
                        }
                        else if (matchValue_12) {
                            matchResult_5 = 0;
                        }
                        else {
                            matchResult_5 = 1;
                        }
                        switch (matchResult_5) {
                            case 0:
                                return new SetId(parse(selectedTool_1.ToolId));
                            default:
                                return undefined;
                        }
                    }, selectedTools)]]);
                }
            }, true, false, "")))))) : empty(), delay(() => {
                let matchValue_14;
                return append(!props.ToolBox.Receiver.IsArchived ? ((matchValue_14 = props.UserData.Role, (matchValue_14 === "toolManager") ? singleton_1(new TableControl$1(t("general.take_back"), Following(), (selectedTools_1) => {
                    if (isEmpty(selectedTools_1)) {
                    }
                    else {
                        setIsUnassignModalSheetOpen([true, [choose((selectedTool_2) => {
                            const matchValue_16 = selectedTool_2.IsSet;
                            let matchResult_6;
                            if (selectedTool_2.IsTool) {
                                if (matchValue_16) {
                                    matchResult_6 = 1;
                                }
                                else {
                                    matchResult_6 = 0;
                                }
                            }
                            else if (matchValue_16) {
                                matchResult_6 = 1;
                            }
                            else {
                                matchResult_6 = 0;
                            }
                            switch (matchResult_6) {
                                case 0:
                                    return new ToolId(parse(selectedTool_2.ToolId));
                                default:
                                    return undefined;
                            }
                        }, selectedTools_1), choose((selectedTool_3) => {
                            const matchValue_19 = selectedTool_3.IsSet;
                            let matchResult_7;
                            if (selectedTool_3.IsTool) {
                                if (matchValue_19) {
                                    matchResult_7 = 1;
                                }
                                else {
                                    matchResult_7 = 1;
                                }
                            }
                            else if (matchValue_19) {
                                matchResult_7 = 0;
                            }
                            else {
                                matchResult_7 = 1;
                            }
                            switch (matchResult_7) {
                                case 0:
                                    return new SetId(parse(selectedTool_3.ToolId));
                                default:
                                    return undefined;
                            }
                        }, selectedTools_1)]]);
                    }
                }, true, false, "")) : ((matchValue_14 === "system") ? singleton_1(new TableControl$1(t("general.take_back"), Following(), (selectedTools_1) => {
                    if (isEmpty(selectedTools_1)) {
                    }
                    else {
                        setIsUnassignModalSheetOpen([true, [choose((selectedTool_2) => {
                            const matchValue_16 = selectedTool_2.IsSet;
                            let matchResult_8;
                            if (selectedTool_2.IsTool) {
                                if (matchValue_16) {
                                    matchResult_8 = 1;
                                }
                                else {
                                    matchResult_8 = 0;
                                }
                            }
                            else if (matchValue_16) {
                                matchResult_8 = 1;
                            }
                            else {
                                matchResult_8 = 0;
                            }
                            switch (matchResult_8) {
                                case 0:
                                    return new ToolId(parse(selectedTool_2.ToolId));
                                default:
                                    return undefined;
                            }
                        }, selectedTools_1), choose((selectedTool_3) => {
                            const matchValue_19 = selectedTool_3.IsSet;
                            let matchResult_9;
                            if (selectedTool_3.IsTool) {
                                if (matchValue_19) {
                                    matchResult_9 = 1;
                                }
                                else {
                                    matchResult_9 = 1;
                                }
                            }
                            else if (matchValue_19) {
                                matchResult_9 = 0;
                            }
                            else {
                                matchResult_9 = 1;
                            }
                            switch (matchResult_9) {
                                case 0:
                                    return new SetId(parse(selectedTool_3.ToolId));
                                default:
                                    return undefined;
                            }
                        }, selectedTools_1)]]);
                    }
                }, true, false, "")) : ((matchValue_14 === "user") ? (empty()) : singleton_1(new TableControl$1(t("general.take_back"), Following(), (selectedTools_1) => {
                    if (isEmpty(selectedTools_1)) {
                    }
                    else {
                        setIsUnassignModalSheetOpen([true, [choose((selectedTool_2) => {
                            const matchValue_16 = selectedTool_2.IsSet;
                            let matchResult_10;
                            if (selectedTool_2.IsTool) {
                                if (matchValue_16) {
                                    matchResult_10 = 1;
                                }
                                else {
                                    matchResult_10 = 0;
                                }
                            }
                            else if (matchValue_16) {
                                matchResult_10 = 1;
                            }
                            else {
                                matchResult_10 = 0;
                            }
                            switch (matchResult_10) {
                                case 0:
                                    return new ToolId(parse(selectedTool_2.ToolId));
                                default:
                                    return undefined;
                            }
                        }, selectedTools_1), choose((selectedTool_3) => {
                            const matchValue_19 = selectedTool_3.IsSet;
                            let matchResult_11;
                            if (selectedTool_3.IsTool) {
                                if (matchValue_19) {
                                    matchResult_11 = 1;
                                }
                                else {
                                    matchResult_11 = 1;
                                }
                            }
                            else if (matchValue_19) {
                                matchResult_11 = 0;
                            }
                            else {
                                matchResult_11 = 1;
                            }
                            switch (matchResult_11) {
                                case 0:
                                    return new SetId(parse(selectedTool_3.ToolId));
                                default:
                                    return undefined;
                            }
                        }, selectedTools_1)]]);
                    }
                }, true, false, "")))))) : empty(), delay(() => {
                    let matchValue_21;
                    return append(!props.ToolBox.Receiver.IsArchived ? ((matchValue_21 = props.UserData.Role, (matchValue_21 === "toolManager") ? singleton_1(new TableControl$1(t("general.report_lost"), Shipment_Search(), (selectedTools_2) => {
                        if (isEmpty(selectedTools_2)) {
                        }
                        else {
                            setIsSetLostStateModalSheetOpen([true, [choose((selectedTool_4) => {
                                const matchValue_23 = selectedTool_4.IsSet;
                                let matchResult_12;
                                if (selectedTool_4.IsTool) {
                                    if (matchValue_23) {
                                        matchResult_12 = 1;
                                    }
                                    else {
                                        matchResult_12 = 0;
                                    }
                                }
                                else if (matchValue_23) {
                                    matchResult_12 = 1;
                                }
                                else {
                                    matchResult_12 = 0;
                                }
                                switch (matchResult_12) {
                                    case 0:
                                        return new ToolId(parse(selectedTool_4.ToolId));
                                    default:
                                        return undefined;
                                }
                            }, selectedTools_2), choose((selectedTool_5) => {
                                const matchValue_26 = selectedTool_5.IsSet;
                                let matchResult_13;
                                if (selectedTool_5.IsTool) {
                                    if (matchValue_26) {
                                        matchResult_13 = 1;
                                    }
                                    else {
                                        matchResult_13 = 1;
                                    }
                                }
                                else if (matchValue_26) {
                                    matchResult_13 = 0;
                                }
                                else {
                                    matchResult_13 = 1;
                                }
                                switch (matchResult_13) {
                                    case 0:
                                        return new SetId(parse(selectedTool_5.ToolId));
                                    default:
                                        return undefined;
                                }
                            }, selectedTools_2)]]);
                        }
                    }, true, false, "")) : ((matchValue_21 === "system") ? singleton_1(new TableControl$1(t("general.report_lost"), Shipment_Search(), (selectedTools_2) => {
                        if (isEmpty(selectedTools_2)) {
                        }
                        else {
                            setIsSetLostStateModalSheetOpen([true, [choose((selectedTool_4) => {
                                const matchValue_23 = selectedTool_4.IsSet;
                                let matchResult_14;
                                if (selectedTool_4.IsTool) {
                                    if (matchValue_23) {
                                        matchResult_14 = 1;
                                    }
                                    else {
                                        matchResult_14 = 0;
                                    }
                                }
                                else if (matchValue_23) {
                                    matchResult_14 = 1;
                                }
                                else {
                                    matchResult_14 = 0;
                                }
                                switch (matchResult_14) {
                                    case 0:
                                        return new ToolId(parse(selectedTool_4.ToolId));
                                    default:
                                        return undefined;
                                }
                            }, selectedTools_2), choose((selectedTool_5) => {
                                const matchValue_26 = selectedTool_5.IsSet;
                                let matchResult_15;
                                if (selectedTool_5.IsTool) {
                                    if (matchValue_26) {
                                        matchResult_15 = 1;
                                    }
                                    else {
                                        matchResult_15 = 1;
                                    }
                                }
                                else if (matchValue_26) {
                                    matchResult_15 = 0;
                                }
                                else {
                                    matchResult_15 = 1;
                                }
                                switch (matchResult_15) {
                                    case 0:
                                        return new SetId(parse(selectedTool_5.ToolId));
                                    default:
                                        return undefined;
                                }
                            }, selectedTools_2)]]);
                        }
                    }, true, false, "")) : ((matchValue_21 === "user") ? (empty()) : singleton_1(new TableControl$1(t("general.report_lost"), Shipment_Search(), (selectedTools_2) => {
                        if (isEmpty(selectedTools_2)) {
                        }
                        else {
                            setIsSetLostStateModalSheetOpen([true, [choose((selectedTool_4) => {
                                const matchValue_23 = selectedTool_4.IsSet;
                                let matchResult_16;
                                if (selectedTool_4.IsTool) {
                                    if (matchValue_23) {
                                        matchResult_16 = 1;
                                    }
                                    else {
                                        matchResult_16 = 0;
                                    }
                                }
                                else if (matchValue_23) {
                                    matchResult_16 = 1;
                                }
                                else {
                                    matchResult_16 = 0;
                                }
                                switch (matchResult_16) {
                                    case 0:
                                        return new ToolId(parse(selectedTool_4.ToolId));
                                    default:
                                        return undefined;
                                }
                            }, selectedTools_2), choose((selectedTool_5) => {
                                const matchValue_26 = selectedTool_5.IsSet;
                                let matchResult_17;
                                if (selectedTool_5.IsTool) {
                                    if (matchValue_26) {
                                        matchResult_17 = 1;
                                    }
                                    else {
                                        matchResult_17 = 1;
                                    }
                                }
                                else if (matchValue_26) {
                                    matchResult_17 = 0;
                                }
                                else {
                                    matchResult_17 = 1;
                                }
                                switch (matchResult_17) {
                                    case 0:
                                        return new SetId(parse(selectedTool_5.ToolId));
                                    default:
                                        return undefined;
                                }
                            }, selectedTools_2)]]);
                        }
                    }, true, false, "")))))) : empty(), delay(() => {
                        if (!props.ToolBox.Receiver.IsArchived) {
                            const matchValue_28 = props.UserData.Role;
                            switch (matchValue_28) {
                                case "user": {
                                    return empty();
                                }
                                default:
                                    return singleton_1(new TableControl$1(t("tool.planned_return_date"), Shipment_Return(), (selectedTools_3) => {
                                        if (isEmpty(selectedTools_3)) {
                                        }
                                        else {
                                            setIsPlannedReturnDateModalSheetOpen([true, [choose((selectedTool_6) => {
                                                const matchValue_30 = selectedTool_6.IsSet;
                                                let matchResult_18;
                                                if (selectedTool_6.IsTool) {
                                                    if (matchValue_30) {
                                                        matchResult_18 = 1;
                                                    }
                                                    else {
                                                        matchResult_18 = 0;
                                                    }
                                                }
                                                else if (matchValue_30) {
                                                    matchResult_18 = 1;
                                                }
                                                else {
                                                    matchResult_18 = 0;
                                                }
                                                switch (matchResult_18) {
                                                    case 0:
                                                        return new ToolId(parse(selectedTool_6.ToolId));
                                                    default:
                                                        return undefined;
                                                }
                                            }, selectedTools_3), choose((selectedTool_7) => {
                                                if (selectedTool_7.IsSet) {
                                                    return new SetId(parse(selectedTool_7.ToolId));
                                                }
                                                else {
                                                    return undefined;
                                                }
                                            }, selectedTools_3)]]);
                                        }
                                    }, true, false, ""));
                            }
                        }
                        else {
                            return empty();
                        }
                    }));
                }));
            }));
        })),
        Options: Options,
        TableKey: "receiver-tools-table",
        TableRows: TableRows,
    })))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function HistorySection(props) {
    let elems_1, TableRows, elems, TableRows_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = [createElement(Table, (TableRows = ((length(props.HistoryRows) > 3) ? toArray(take(3, props.HistoryRows)) : toArray(props.HistoryRows)), {
        ColumnDefinitions: toArray_1(delay(() => append(singleton_1(new ColumnDefinition$1("eventDate", "", t("general.date"), (row) => (new CellContent(7, [row.EventDate])), "none", "dateTime")), delay(() => append(singleton_1(new ColumnDefinition$1("eventType", "", t("general.event"), (row_1) => (new CellContent(0, [t(row_1.EventType)])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("toolName", "", t("general.tool"), (row_2) => (new CellContent(0, [row_2.InventoryName])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_3) => (new CellContent(0, [row_3.InventoryNumber])), "none", "text")), delay(() => append((props.State.Customer.tag === 1) ? singleton_1(new ColumnDefinition$1("checkNumber", "", t("tool.prinzing.check_number"), (row_4) => (new CellContent(0, [defaultArg(row_4.CheckNumber, "")])), "text", "text")) : (empty()), delay(() => append(singleton_1(new ColumnDefinition$1("quantity", "", t("general.quantity"), (row_5) => (new CellContent(0, [row_5.Quantity])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("comment", "", t("general.comment"), (row_6) => (new CellContent(0, [row_6.Comment])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("signatureUrl", "", t("general.signature"), (row_7) => (new CellContent(4, [defaultArg(row_7.SignatureUrl, "")])), "none", "image")), delay(() => append(singleton_1(new ColumnDefinition$1("commission", "", t("general.commission"), (dto) => (new CellContent(0, [dto.CommissionNumber])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("receiver", "", t("general.receiver"), (row_8) => (new CellContent(0, [row_8.Receiver])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("sender", "", t("general.sender"), (row_9) => (new CellContent(0, [row_9.Sender])), "none", "text")), delay(() => singleton_1(new ColumnDefinition$1("storage", "", t("general.storage"), (row_10) => (new CellContent(0, [row_10.Storage])), "none", "text")))))))))))))))))))))))))),
        Controls: empty_1(),
        Options: {
            BorderStyle: "row",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["eventDate", "desc"],
            Fullscreen: false,
            GlobalSearch: false,
            OnRowClick: new OnTableRowClick$1(1, [(row_11) => {
                const matchValue_1 = row_11.ToolHistoryElementType;
                return (matchValue_1.tag === 1) ? RouterModule_encodeParts(ofArray(["toolswithquantity", unwrapToolId(matchValue_1.fields[0])]), 1) : ((matchValue_1.tag === 2) ? RouterModule_encodeParts(ofArray(["receivers", props.ToolBox.Receiver.Id]), 1) : ((matchValue_1.tag === 3) ? RouterModule_encodeParts(ofArray(["consumables", ConsumableId__get_unwrap(matchValue_1.fields[0])]), 1) : RouterModule_encodeParts(ofArray(["tools", unwrapToolId(matchValue_1.fields[0])]), 1)));
            }]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    })), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
        ComponentState: "enabled",
        Label: t("general.show_more_data"),
        OnClick: () => {
            setIsModalOpen(true);
        },
        TestId: "toolbox-history-show-more-data-button",
        Variant: "blueButton",
    }), createElement(ModalSheet, {
        CloseButtonTestId: "modal-sheet-history-close-button",
        Content: createElement(Table, (TableRows_1 = toArray(props.HistoryRows), {
            ColumnDefinitions: toArray_1(delay(() => append(singleton_1(new ColumnDefinition$1("eventDate", "", t("general.date"), (row_12) => (new CellContent(7, [row_12.EventDate])), "none", "dateTime")), delay(() => append(singleton_1(new ColumnDefinition$1("eventType", "", t("general.event"), (row_13) => (new CellContent(0, [t(row_13.EventType)])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("toolName", "", t("general.tool"), (row_14) => (new CellContent(0, [row_14.InventoryName])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_15) => (new CellContent(0, [row_15.InventoryNumber])), "none", "text")), delay(() => append((props.State.Customer.tag === 1) ? singleton_1(new ColumnDefinition$1("checkNumber", "", t("tool.prinzing.check_number"), (row_16) => (new CellContent(0, [defaultArg(row_16.CheckNumber, "")])), "text", "text")) : (empty()), delay(() => append(singleton_1(new ColumnDefinition$1("quantity", "", t("general.quantity"), (row_17) => (new CellContent(0, [row_17.Quantity])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("comment", "", t("general.comment"), (row_18) => (new CellContent(0, [row_18.Comment])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("signatureUrl", "", t("general.signature"), (row_19) => (new CellContent(4, [defaultArg(row_19.SignatureUrl, "")])), "none", "image")), delay(() => append(singleton_1(new ColumnDefinition$1("receiver", "", t("general.receiver"), (row_20) => (new CellContent(0, [row_20.Receiver])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("sender", "", t("general.sender"), (row_21) => (new CellContent(0, [row_21.Sender])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("storage", "", t("general.storage"), (row_22) => (new CellContent(0, [row_22.Storage])), "none", "text")), delay(() => Table_customPropertyValueDtoColumnDefinitions(props.PropertyConfigurations, t("tool.custom_properties"), (dto_1) => dto_1.CustomProperties, t))))))))))))))))))))))))),
            Controls: empty_1(),
            Options: {
                BorderStyle: "full",
                CSVDownload: true,
                ConfigurableColumns: true,
                CustomTableFilters: false,
                DefaultSortColumn: ["eventDate", "desc"],
                Fullscreen: false,
                GlobalSearch: false,
                OnRowClick: new OnTableRowClick$1(1, [(row_23) => {
                    const matchValue_3 = row_23.ToolHistoryElementType;
                    return (matchValue_3.tag === 1) ? RouterModule_encodeParts(ofArray(["toolswithquantity", unwrapToolId(matchValue_3.fields[0])]), 1) : ((matchValue_3.tag === 2) ? RouterModule_encodeParts(ofArray(["receivers", props.ToolBox.Receiver.Id]), 1) : ((matchValue_3.tag === 3) ? RouterModule_encodeParts(ofArray(["consumables", ConsumableId__get_unwrap(matchValue_3.fields[0])]), 1) : RouterModule_encodeParts(ofArray(["tools", unwrapToolId(matchValue_3.fields[0])]), 1)));
                }]),
                RowSelection: "disabled",
                SaveTableConfiguration: false,
            },
            TableKey: "not-defined-table",
            TableRows: TableRows_1,
        })),
        Controls: empty_1(),
        IsModalOpen: patternInput_1[0],
        OnClose: () => {
            setIsModalOpen(false);
        },
        Title: t("general.history"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ConsumableSection(props) {
    let elems_2;
    const patternInput = reactApi.useState(false);
    const setIsToolModalOpen = patternInput[1];
    const patternInput_1 = reactApi.useState([false, empty_1()]);
    const setIsAssignModalSheetOpen = patternInput_1[1];
    const isAssignModalSheetOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState([false, empty_1()]);
    const setIsUnassignModalSheetOpen = patternInput_2[1];
    const isUnassignModalSheetOpen = patternInput_2[0];
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_2 = toList(delay(() => {
        let elems_1;
        const table = (rows) => {
            let TableRows, Options;
            return createElement(Table, (TableRows = toArray(rows), (Options = {
                BorderStyle: "row",
                CSVDownload: true,
                ConfigurableColumns: true,
                CustomTableFilters: false,
                DefaultSortColumn: ["consumableName", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                OnRowClick: new OnTableRowClick$1(1, [(row_5) => RouterModule_encodeParts(ofArray(["consumables", row_5.Id]), 1)]),
                RowSelection: "multiRow",
                SaveTableConfiguration: true,
            }, {
                ColumnDefinitions: toArray_1(delay(() => append(singleton_1(new ColumnDefinition$1("consumableName", "", t("general.consumable"), (row) => (new CellContent(0, [row.ConsumableName])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("additionalName", "", t("consumable.additional_name"), (row_1) => (new CellContent(0, [row_1.AdditionalName])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_2) => (new CellContent(0, [row_2.InventoryNumber])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("quantity", "", t("general.quantity"), (row_3) => (new CellContent(0, [row_3.Quantity])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("unit", "", t("general.unit"), (row_4) => (new CellContent(0, [t(Helper_unitToTranslationKey(row_4.Unit))])), "none", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("purchase_price", t("tool.commercial_data"), t("general.purchase_price"), (consumable) => (new CellContent(0, [consumable.PurchasePrice])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("purchaseDate", t("tool.commercial_data"), t("general.purchase_date"), (consumable_1) => (new CellContent(6, [consumable_1.PurchaseDate])), "dateRange", "date")), delay(() => append(singleton_1(new ColumnDefinition$1("supplier", t("tool.commercial_data"), t("general.supplier"), (consumable_2) => (new CellContent(0, [consumable_2.Supplier])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("supplier_artice_number", t("tool.commercial_data"), t("general.supplier_article_number"), (consumable_3) => (new CellContent(0, [consumable_3.SupplierArticleNumber])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("warranty_date", t("tool.commercial_data"), t("general.gurantee_date"), (consumable_4) => (new CellContent(6, [consumable_4.WarrantyDate])), "dateRange", "date")), delay(() => append(singleton_1(new ColumnDefinition$1("commercial_data_comment", t("tool.commercial_data"), t("general.comment"), (consumable_5) => (new CellContent(0, [consumable_5.CommercialDataComment])), "text", "text")), delay(() => Table_customPropertyValueDtoColumnDefinitions(filter((propertyConfiguration) => {
                    const matchValue = propertyConfiguration.Visibility;
                    switch (matchValue.tag) {
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 12:
                        case 11:
                            return false;
                        default:
                            return true;
                    }
                }, props.PropertyConfigurations), t("tool.custom_properties"), (dto) => dto.CustomProperties, t))))))))))))))))))))))))),
                Controls: toList(delay(() => {
                    let matchValue_1;
                    return append(!props.ToolBox.Receiver.IsArchived ? ((matchValue_1 = props.UserData.Role, (matchValue_1 === "toolManager") ? singleton_1(new TableControl$1(t("general.assign"), Following(), (selectedConsumables) => {
                        if (isEmpty(selectedConsumables)) {
                        }
                        else {
                            setIsAssignModalSheetOpen([true, map((consumable_6) => (new ConsumableId(parse(consumable_6.Id))), selectedConsumables)]);
                        }
                    }, true, false, "")) : ((matchValue_1 === "system") ? singleton_1(new TableControl$1(t("general.assign"), Following(), (selectedConsumables) => {
                        if (isEmpty(selectedConsumables)) {
                        }
                        else {
                            setIsAssignModalSheetOpen([true, map((consumable_6) => (new ConsumableId(parse(consumable_6.Id))), selectedConsumables)]);
                        }
                    }, true, false, "")) : ((matchValue_1 === "user") ? (empty()) : singleton_1(new TableControl$1(t("general.assign"), Following(), (selectedConsumables) => {
                        if (isEmpty(selectedConsumables)) {
                        }
                        else {
                            setIsAssignModalSheetOpen([true, map((consumable_6) => (new ConsumableId(parse(consumable_6.Id))), selectedConsumables)]);
                        }
                    }, true, false, "")))))) : empty(), delay(() => {
                        if (!props.ToolBox.Receiver.IsArchived) {
                            const matchValue_2 = props.UserData.Role;
                            switch (matchValue_2) {
                                case "user": {
                                    return empty();
                                }
                                default:
                                    return singleton_1(new TableControl$1(t("general.take_back"), Following(), (selectedConsumables_1) => {
                                        if (isEmpty(selectedConsumables_1)) {
                                        }
                                        else {
                                            setIsUnassignModalSheetOpen([true, map((consumable_7) => (new ConsumableId(parse(consumable_7.Id))), selectedConsumables_1)]);
                                        }
                                    }, true, false, ""));
                            }
                        }
                        else {
                            return empty();
                        }
                    }));
                })),
                Options: Options,
                TableKey: "receiver-consumable-table",
                TableRows: TableRows,
            })));
        };
        return singleton_1(reactElement("div", createObj(ofArray([["id", "consumable-stock-section"], ["className", join(" ", ["flex", "flex-col", "bg-white"])], (elems_1 = toList(delay(() => append(singleton_1(createElement(MultiAssignModalSheet, {
            AssignProps: {
                ConsumableIds: isAssignModalSheetOpen[1],
                SetIds: empty_1(),
                ToolIds: empty_1(),
            },
            CustomerConfiguration: props.CustomerConfiguration,
            IsOpen: isAssignModalSheetOpen[0],
            OnClose: () => {
                setIsAssignModalSheetOpen([false, empty_1()]);
            },
            PredefinedQuantities: empty_1(),
            ReceiverId: props.ToolBox.Receiver.Id,
            SenderId: props.ToolBox.Receiver.Id,
            SuccessCallback: () => {
                props.Dispatch(new Msg(27, []));
            },
            UserData: props.UserData,
        })), delay(() => append(singleton_1(createElement(MultiUnassignModalSheet, {
            CustomerConfiguration: props.CustomerConfiguration,
            IsOpen: isUnassignModalSheetOpen[0],
            OnClose: () => {
                setIsUnassignModalSheetOpen([false, empty_1()]);
            },
            SenderId: props.ToolBox.Receiver.Id,
            SuccessCallback: () => {
                props.Dispatch(new Msg(27, []));
            },
            UnassignProps: {
                ConsumableIds: isUnassignModalSheetOpen[1],
                SetIds: empty_1(),
                ToolIds: empty_1(),
            },
            UserData: props.UserData,
        })), delay(() => append(singleton_1(table((length(props.ConsumableStockRows) > 5) ? take(5, props.ConsumableStockRows) : props.ConsumableStockRows)), delay(() => {
            let elems;
            return (length(props.ConsumableStockRows) > 5) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                ComponentState: "enabled",
                Label: t("general.show_more_data"),
                OnClick: () => {
                    setIsToolModalOpen(true);
                },
                TestId: "tool-toolwithquantity-toolsincirculation-showmoredata-button",
                Variant: "blueButton",
            }), createElement(ModalSheet, {
                CloseButtonTestId: "",
                Content: table(props.ConsumableStockRows),
                Controls: empty_1(),
                IsModalOpen: patternInput[0],
                OnClose: () => {
                    setIsToolModalOpen(false);
                },
                Title: t("navbar.consumables"),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
        })))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function PermissionSection(props) {
    let elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(Table, (TableRows = toArray(props.Permissions.Storages), {
        ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.storage"), (permission) => (new CellContent(0, [permission.Name])), "none", "text"), new ColumnDefinition$1("permissionType", "", t("general.storage"), (permission_1) => (new CellContent(0, [t(StoragePermissionType__ToI18nString(permission_1.PermissionType))])), "none", "text")],
        Controls: empty_1(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function VisibleUserSection(props) {
    let elems;
    const t = useTranslation()[0];
    const columnDefinitions = toArray_1(delay(() => append(singleton_1(new ColumnDefinition$1("name", "", t("general.name"), (dto) => (new CellContent(0, [dto.Name])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("personnelNumber", "", t("user.personnel_number"), (dto_1) => (new CellContent(0, [dto_1.PersonnelNumber])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("department", "", t("user.department"), (dto_2) => (new CellContent(0, [dto_2.Department])), "select", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("role", "", t("general.role"), (dto_3) => (new CellContent(0, [t(concat("role.", ...roleToString(dto_3.Role)))])), "select", "text")), delay(() => Table_customPropertyColumnDefinitions(filter((propertyConfiguration) => {
        const matchValue = propertyConfiguration.Visibility;
        switch (matchValue.tag) {
            case 0:
            case 1:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 12:
            case 11:
                return false;
            default:
                return true;
        }
    }, props.PropertyConfigurations), t("tool.custom_properties"), (dto_4) => dto_4.CustomProperties, t, props.CustomerConfiguration.Currency)))))))))));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(Table, {
        ColumnDefinitions: columnDefinitions,
        Controls: empty_1(),
        Options: {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: toArray(props.Users),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function VisibleReceiverSection(props) {
    let elems, Title, TableRows, Options;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsAddReceiverModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setIsRemoveReceiverDialogOpen = patternInput_2[1];
    const isRemoveReceiverDialogOpen = patternInput_2[0];
    const columnDefinitions = [new ColumnDefinition$1("name", "", t("general.name"), (dto) => (new CellContent(0, [dto.Name])), "text", "text"), new ColumnDefinition$1("receiverType", "", t("general.receiver"), (dto_1) => {
        let matchValue;
        return new CellContent(0, [(matchValue = dto_1.ReceiverType, (matchValue.tag === 0) ? t("receivers.users") : ((matchValue.tag === 2) ? t("receivers.externalpersons") : ((matchValue.tag === 3) ? t("receivers.subcontractors") : ((matchValue.tag === 4) ? t("receivers.rooms") : ((matchValue.tag === 5) ? t("receivers.projects") : ((matchValue.tag === 6) ? t("receivers.constructionsites") : ((matchValue.tag === 7) ? t("receivers.students") : ((matchValue.tag === 8) ? t("receivers.school_classes") : ((matchValue.tag === 9) ? t("receivers.vehicles") : ((matchValue.tag === 10) ? t("receivers.api_receivers") : t("receivers.employees")))))))))))]);
    }, "text", "text")];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(ConfirmationDialog, (Title = t("general.remove"), {
        Description: t("toolbox.delete_visible_receiver_confirm"),
        IsOpen: isRemoveReceiverDialogOpen != null,
        OnClose: () => {
            setIsRemoveReceiverDialogOpen(undefined);
        },
        OnConfirm: () => {
            if (isRemoveReceiverDialogOpen == null) {
            }
            else {
                props.Dispatch(new Msg(31, [isRemoveReceiverDialogOpen.Id]));
                setIsRemoveReceiverDialogOpen(undefined);
            }
        },
        Title: Title,
    })), createElement(AddVisibleReceiverToUserModal, {
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsAddReceiverModalOpen(false);
        },
        SuccessCallback: () => {
            setIsAddReceiverModalOpen(false);
            props.Dispatch(new Msg(27, []));
        },
        UserData: props.UserData,
        UserId: props.ToolBox.Receiver.Id,
        VisibleReceiver: props.ToolBox.VisibleReceivers,
    }), createElement(Table, (TableRows = toArray(props.ToolBox.VisibleReceivers), (Options = {
        BorderStyle: "row",
        CSVDownload: false,
        ConfigurableColumns: false,
        CustomTableFilters: false,
        DefaultSortColumn: ["name", "asc"],
        Fullscreen: false,
        GlobalSearch: false,
        OnRowClick: new OnTableRowClick$1(1, [(dto_2) => RouterModule_encodeParts(ofArray(["receivers", dto_2.Id]), 1)]),
        RowSelection: "singleRow",
        SaveTableConfiguration: false,
    }, {
        ColumnDefinitions: columnDefinitions,
        Controls: toList(delay(() => {
            const matchValue_1 = props.UserData.Role;
            switch (matchValue_1) {
                case "toolManager":
                case "user": {
                    return empty();
                }
                default:
                    return append(singleton_1(new TableControl$1(t("general.add"), Shipment_Add(), (_arg) => {
                        setIsAddReceiverModalOpen(true);
                    }, false, false, "add-tool")), delay(() => singleton_1(new TableControl$1(t("general.remove"), Recycle_Bin_1(), (visibleReceivers) => {
                        setIsRemoveReceiverDialogOpen(tryHead(visibleReceivers));
                    }, true, false, "toolbox-remove-visible-receiver-button"))));
            }
        })),
        Options: Options,
        TableKey: "not-defined-table",
        TableRows: TableRows,
    })))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function DocumentSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton_1(createElement(DocumentTable, {
        AdditionalColumns: empty_1(),
        Documents: (length(props.Documents) > 5) ? take(5, props.Documents) : props.Documents,
        OnDownloadFile: (tupledArg) => {
            props.Dispatch(new Msg(9, [tupledArg[0], tupledArg[1]]));
        },
        UploadSuccessCallback: () => {
            props.Dispatch(new Msg(16, []));
        },
        UploadType: new UploadType_2(4, [props.ReceiverId]),
        UserData: props.UserData,
    })), delay(() => {
        let elems, Title;
        return (length(props.Documents) > 5) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsModalOpen(true);
            },
            TestId: "tool-selectcard-tooldetail-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, (Title = t("general.documents"), {
            CloseButtonTestId: "",
            Content: createElement(DocumentTable, {
                AdditionalColumns: empty_1(),
                Documents: props.Documents,
                OnDownloadFile: (tupledArg_1) => {
                    props.Dispatch(new Msg(9, [tupledArg_1[0], tupledArg_1[1]]));
                },
                UploadSuccessCallback: () => {
                    props.Dispatch(new Msg(16, []));
                },
                UploadType: new UploadType_2(4, [props.ReceiverId]),
                UserData: props.UserData,
            }),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsModalOpen(false);
            },
            Title: unwrap(Title),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function PlanningSection(props) {
    const patternInput = useTranslation();
    const xs_1 = [createElement(ReservationTable, {
        Options: {
            Controls: empty_1(),
            DisplayReceiverName: false,
            IsReservationStateVisible: false,
            OnRowClick: new OnTableRowClick$1(1, [(dto) => {
                let matchValue;
                return RouterModule_encodeParts(ofArray(["reservations", (matchValue = dto.GroupId, (matchValue == null) ? dto.Id : matchValue)]), 1);
            }]),
            RowSelection: "multiRow",
        },
        Reservations: props.Reservations,
        UserData: props.UserData,
    })];
    return react.createElement(react.Fragment, {}, ...xs_1);
}

function BarcodeSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton_1(createElement(QrCodeTable, {
        OnAssignQrCode: (arg) => {
            props.Dispatch(new Msg(5, [arg]));
        },
        OnDeleteQrCodes: (arg_1) => {
            props.Dispatch(new Msg(7, [arg_1]));
        },
        QrCodes: (length(props.QRCodeIds) > 5) ? take(5, props.QRCodeIds) : props.QRCodeIds,
        UserData: props.UserData,
    })), delay(() => {
        let elems, Title;
        return (length(props.QRCodeIds) > 5) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsModalOpen(true);
            },
            TestId: "tool-selectcard-tooldetail-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, (Title = t("general.qr_code"), {
            CloseButtonTestId: "",
            Content: createElement(QrCodeTable, {
                OnAssignQrCode: (arg_2) => {
                    props.Dispatch(new Msg(5, [arg_2]));
                },
                OnDeleteQrCodes: (arg_3) => {
                    props.Dispatch(new Msg(7, [arg_3]));
                },
                QrCodes: props.QRCodeIds,
                UserData: props.UserData,
            }),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsModalOpen(false);
            },
            Title: unwrap(Title),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ToolBoxDetails(props) {
    let elems_17, Title, elems, Title_1, matchValue, matchValue_1, matchValue_3, matchValue_2, elems_1, elems_16;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsDeleteDialogOpen = patternInput_1[1];
    const isDeleteDialogOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState("overview-section-id");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[10rem,min(calc(100vw-16rem-2px-28px-11rem),80rem)]", "print:flex", "print:flex-col"])], (elems_17 = [createElement(ConfirmationDialog, (Title = t("general.remove"), {
        Description: t("toolbox.delete_receiver_confirm"),
        IsOpen: isDeleteDialogOpen,
        OnClose: () => {
            setIsDeleteDialogOpen(false);
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(30, [new UserId_1(props.ToolBox.Receiver.Id)]));
        },
        Title: Title,
    })), reactElement("div", createObj(ofArray([["className", join(" ", ["col-span-2", "print:hidden"])], (elems = [createElement(DetailViewHeader, (Title_1 = t("toolbox.detail_toolbox"), {
        Badges: empty_1(),
        OnBack: props.OnBack,
        OnDelete: unwrap((matchValue = props.UserData.Role, (matchValue === "administrator") ? (() => {
            setIsDeleteDialogOpen(!isDeleteDialogOpen);
        }) : ((matchValue === "toolManager") ? undefined : ((matchValue === "user") ? undefined : (() => {
            setIsDeleteDialogOpen(!isDeleteDialogOpen);
        }))))),
        OnEdit: unwrap(props.ToolBox.Receiver.IsArchived ? undefined : ((matchValue_1 = props.ToolBox.Receiver.ReceiverType, (matchValue_1.tag === 3) ? ((matchValue_3 = props.UserData.Role, (matchValue_3 === "system") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "administrator") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }))))) : ((matchValue_1.tag === 2) ? ((matchValue_3 = props.UserData.Role, (matchValue_3 === "system") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "administrator") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }))))) : ((matchValue_1.tag === 5) ? ((matchValue_3 = props.UserData.Role, (matchValue_3 === "system") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "administrator") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }))))) : ((matchValue_1.tag === 6) ? ((matchValue_3 = props.UserData.Role, (matchValue_3 === "system") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "administrator") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }))))) : ((matchValue_1.tag === 7) ? ((matchValue_3 = props.UserData.Role, (matchValue_3 === "system") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "administrator") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }))))) : ((matchValue_1.tag === 8) ? ((matchValue_3 = props.UserData.Role, (matchValue_3 === "system") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "administrator") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }))))) : ((matchValue_1.tag === 4) ? ((matchValue_3 = props.UserData.Role, (matchValue_3 === "system") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "administrator") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }))))) : ((matchValue_1.tag === 9) ? ((matchValue_3 = props.UserData.Role, (matchValue_3 === "system") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "administrator") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }))))) : ((matchValue_1.tag === 10) ? ((matchValue_3 = props.UserData.Role, (matchValue_3 === "system") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "administrator") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }))))) : ((matchValue_1.tag === 1) ? ((matchValue_3 = props.UserData.Role, (matchValue_3 === "system") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "administrator") ? (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }) : ((matchValue_3 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(props.ToolBox.Receiver.ReceiverType), props.ToolBox.Receiver.Id, "edit"]), 1, 1);
        }))))) : ((matchValue_2 = props.UserData.Role, (matchValue_2 === "administrator") ? props.OnEdit : ((matchValue_2 === "toolManager") ? undefined : ((matchValue_2 === "user") ? undefined : props.OnEdit)))))))))))))))),
        Title: Title_1,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["print:hidden"])], (elems_1 = [createElement(AreaAnchorMenu, {
        Anchors: toList(delay(() => append(singleton_1({
            Id: "overview-section-id",
            Label: t("general.overview"),
        }), delay(() => append(!equals(props.ToolBox.Receiver.ReceiverType, new ReceiverTypeName(10, [])) ? append(singleton_1({
            Id: "inventory-section-id",
            Label: t("navbar.tools"),
        }), delay(() => append(singleton_1({
            Id: "consumables-section-id",
            Label: t("navbar.consumables"),
        }), delay(() => append(singleton_1({
            Id: "planning-section",
            Label: t("tool.planning.title"),
        }), delay(() => singleton_1({
            Id: "documents-section-id",
            Label: t("general.documents"),
        }))))))) : empty(), delay(() => {
            let matchValue_4;
            return append(!(props.UserData.Role === "user") ? ((matchValue_4 = props.ToolBox.Receiver.ReceiverType, (matchValue_4.tag === 5) ? (empty()) : ((matchValue_4.tag === 4) ? (empty()) : ((matchValue_4.tag === 9) ? (empty()) : ((matchValue_4.tag === 6) ? (empty()) : ((matchValue_4.tag === 8) ? (empty()) : ((matchValue_4.tag === 7) ? (empty()) : ((matchValue_4.tag === 3) ? (empty()) : ((matchValue_4.tag === 1) ? (empty()) : ((matchValue_4.tag === 2) ? (empty()) : ((matchValue_4.tag === 10) ? (empty()) : singleton_1({
                Id: "permissions-section-id",
                Label: t("settings.permissions"),
            })))))))))))) : empty(), delay(() => {
                let matchValue_5;
                return append(isFeatureEnabled(new Feature(13, [])) ? ((matchValue_5 = props.ToolBox.Receiver.ReceiverType, (matchValue_5.tag === 4) ? singleton_1({
                    Id: "visible-user-section-id",
                    Label: t("receivers.visible_for"),
                }) : ((matchValue_5.tag === 9) ? singleton_1({
                    Id: "visible-user-section-id",
                    Label: t("receivers.visible_for"),
                }) : ((matchValue_5.tag === 6) ? singleton_1({
                    Id: "visible-user-section-id",
                    Label: t("receivers.visible_for"),
                }) : ((matchValue_5.tag === 8) ? (empty()) : ((matchValue_5.tag === 0) ? (empty()) : ((matchValue_5.tag === 7) ? (empty()) : ((matchValue_5.tag === 3) ? (empty()) : ((matchValue_5.tag === 1) ? (empty()) : ((matchValue_5.tag === 2) ? (empty()) : ((matchValue_5.tag === 10) ? (empty()) : singleton_1({
                    Id: "visible-user-section-id",
                    Label: t("receivers.visible_for"),
                })))))))))))) : (empty()), delay(() => {
                    let matchValue_6;
                    return append((matchValue_6 = props.ToolBox.Receiver.ReceiverType, (matchValue_6.tag === 8) ? (empty()) : ((matchValue_6.tag === 5) ? (empty()) : ((matchValue_6.tag === 4) ? (empty()) : ((matchValue_6.tag === 9) ? (empty()) : ((matchValue_6.tag === 6) ? (empty()) : ((matchValue_6.tag === 7) ? (empty()) : ((matchValue_6.tag === 3) ? (empty()) : ((matchValue_6.tag === 1) ? (empty()) : ((matchValue_6.tag === 2) ? (empty()) : ((matchValue_6.tag === 10) ? (empty()) : singleton_1({
                        Id: "visible-receiver-section-id",
                        Label: t("general.visible_receiver"),
                    }))))))))))), delay(() => append((!(props.UserData.Role === "user") && !equals(props.ToolBox.Receiver.ReceiverType, new ReceiverTypeName(10, []))) ? singleton_1({
                        Id: "barcodes-section-id",
                        Label: t("general.qr_code"),
                    }) : empty(), delay(() => (!(props.UserData.Role === "user") ? singleton_1({
                        Id: "history-section-id",
                        Label: t("general.history"),
                    }) : empty())))));
                }));
            }));
        })))))),
        OnSelectAnchor: patternInput_2[1],
        SelectedAnchor: patternInput_2[0],
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_16 = toList(delay(() => {
        let elems_2;
        return append((props.AccountSettings.InspectionsEnabled && isFeatureEnabled(new Feature(21, []))) ? (exists((tool) => {
            const matchValue_7 = tool.InspectionStatus;
            let matchResult;
            if (matchValue_7 != null) {
                switch (matchValue_7.tag) {
                    case 1:
                    case 2:
                    case 3: {
                        matchResult = 0;
                        break;
                    }
                    default:
                        matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return true;
                default:
                    return false;
            }
        }, props.ToolRows) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3"])], (elems_2 = [createElement(WarningAlert, {
            Label: t("toolbox.has_uninspected_tools"),
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty()) : empty(), delay(() => {
            let elems_3;
            return append(singleton_1(reactElement("section", createObj(ofArray([["id", "overview-section-id"], (elems_3 = [createElement(ToolboxHeaderSection, {
                AccountSettings: props.AccountSettings,
                Customer: props.State.Customer,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: props.Dispatch,
                HistoryRows: props.HistoryRows,
                Locations: props.Locations,
                PropertyConfigurations: props.PropertyConfigurations,
                Receiver: props.ToolBox.Receiver,
                Toolbox: props.ToolBox,
                TriggerRerender: props.State.TriggerRerender,
                UserData: props.UserData,
            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                let elems_7, elems_6, elems_4, elems_5;
                return append(!equals(props.ToolBox.Receiver.ReceiverType, new ReceiverTypeName(10, [])) ? append(singleton_1(reactElement("section", createObj(ofArray([["id", "inventory-section-id"], (elems_7 = [reactElement("div", createObj(ofArray([["data-test-id", "toolbox-detail-inventory-table-heading"], ["className", join(" ", ["mt-8"])], (elems_6 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_4 = [createElement(BlockHeader, {
                    Text: t("navbar.tools"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white"])], (elems_5 = [createElement(ToolboxToolsSection, {
                    AccountSettings: props.AccountSettings,
                    CustomerConfiguration: props.CustomerConfiguration,
                    Dispatch: props.Dispatch,
                    State: props.State,
                    ToolBox: props.ToolBox,
                    ToolRows: props.ToolRows,
                    UserData: props.UserData,
                })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                    let elems_8, Title_2;
                    return append(singleton_1(reactElement("section", createObj(ofArray([["id", "consumables-section-id"], (elems_8 = [createElement(TableContainer, (Title_2 = t("navbar.consumables"), {
                        Content: createElement(ConsumableSection, {
                            ConsumableStockRows: props.ToolBox.ConsumableStock,
                            CustomerConfiguration: props.CustomerConfiguration,
                            Dispatch: props.Dispatch,
                            PropertyConfigurations: props.PropertyConfigurations,
                            State: props.State,
                            ToolBox: props.ToolBox,
                            UserData: props.UserData,
                        }),
                        Title: unwrap(Title_2),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                        let elems_9, Title_3;
                        return append(singleton_1(reactElement("section", createObj(ofArray([["id", "planning-section"], (elems_9 = [createElement(TableContainer, (Title_3 = t("tool.planning.title"), {
                            Content: createElement(PlanningSection, {
                                CustomerConfiguration: props.CustomerConfiguration,
                                Dispatch: props.Dispatch,
                                Reservations: props.Reservations,
                                ToolBox: props.ToolBox,
                                UserData: props.UserData,
                            }),
                            Title: unwrap(Title_3),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => {
                            let elems_10, Title_4;
                            return singleton_1(reactElement("section", createObj(ofArray([["id", "documents-section-id"], ["className", join(" ", ["print:hidden"])], (elems_10 = [createElement(TableContainer, (Title_4 = t("general.documents"), {
                                Content: createElement(DocumentSection, {
                                    Dispatch: props.Dispatch,
                                    Documents: props.Documents,
                                    IsVisibleForUser: false,
                                    ReceiverId: props.ToolBox.Receiver.Id,
                                    UserData: props.UserData,
                                }),
                                Title: unwrap(Title_4),
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))));
                        }));
                    }));
                })) : empty(), delay(() => {
                    let matchValue_8, elems_11, Title_5;
                    return append(!(props.UserData.Role === "user") ? ((matchValue_8 = props.ToolBox.Receiver.ReceiverType, (matchValue_8.tag === 5) ? (empty()) : ((matchValue_8.tag === 4) ? (empty()) : ((matchValue_8.tag === 9) ? (empty()) : ((matchValue_8.tag === 6) ? (empty()) : ((matchValue_8.tag === 8) ? (empty()) : ((matchValue_8.tag === 7) ? (empty()) : ((matchValue_8.tag === 3) ? (empty()) : ((matchValue_8.tag === 1) ? (empty()) : ((matchValue_8.tag === 2) ? (empty()) : ((matchValue_8.tag === 10) ? (empty()) : singleton_1(reactElement("section", createObj(ofArray([["id", "permissions-section-id"], ["className", join(" ", ["print:hidden"])], (elems_11 = [createElement(TableContainer, (Title_5 = t("settings.permissions"), {
                        Content: createElement(PermissionSection, {
                            Permissions: props.ToolBox.Permissions,
                            State: props.State,
                        }),
                        Title: unwrap(Title_5),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_11))])]))))))))))))))) : empty(), delay(() => {
                        let matchValue_9, elems_12, Title_6;
                        return append((matchValue_9 = props.ToolBox.Receiver.ReceiverType, (matchValue_9.tag === 4) ? (isFeatureEnabled(new Feature(13, [])) ? singleton_1(reactElement("section", createObj(ofArray([["id", "visible-user-section-id"], ["className", join(" ", ["print:hidden"])], (elems_12 = [createElement(TableContainer, (Title_6 = t("receivers.visible_for"), {
                            Content: createElement(VisibleUserSection, {
                                CustomerConfiguration: props.CustomerConfiguration,
                                PropertyConfigurations: props.PropertyConfigurations,
                                Users: props.ToolBox.VisibleUsers,
                            }),
                            Title: unwrap(Title_6),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))) : (empty())) : ((matchValue_9.tag === 9) ? (isFeatureEnabled(new Feature(13, [])) ? singleton_1(reactElement("section", createObj(ofArray([["id", "visible-user-section-id"], ["className", join(" ", ["print:hidden"])], (elems_12 = [createElement(TableContainer, (Title_6 = t("receivers.visible_for"), {
                            Content: createElement(VisibleUserSection, {
                                CustomerConfiguration: props.CustomerConfiguration,
                                PropertyConfigurations: props.PropertyConfigurations,
                                Users: props.ToolBox.VisibleUsers,
                            }),
                            Title: unwrap(Title_6),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))) : (empty())) : ((matchValue_9.tag === 6) ? (isFeatureEnabled(new Feature(13, [])) ? singleton_1(reactElement("section", createObj(ofArray([["id", "visible-user-section-id"], ["className", join(" ", ["print:hidden"])], (elems_12 = [createElement(TableContainer, (Title_6 = t("receivers.visible_for"), {
                            Content: createElement(VisibleUserSection, {
                                CustomerConfiguration: props.CustomerConfiguration,
                                PropertyConfigurations: props.PropertyConfigurations,
                                Users: props.ToolBox.VisibleUsers,
                            }),
                            Title: unwrap(Title_6),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))) : (empty())) : ((matchValue_9.tag === 8) ? (empty()) : ((matchValue_9.tag === 7) ? (empty()) : ((matchValue_9.tag === 3) ? (empty()) : ((matchValue_9.tag === 1) ? (empty()) : ((matchValue_9.tag === 0) ? (empty()) : ((matchValue_9.tag === 2) ? (empty()) : ((matchValue_9.tag === 10) ? (empty()) : (isFeatureEnabled(new Feature(13, [])) ? singleton_1(reactElement("section", createObj(ofArray([["id", "visible-user-section-id"], ["className", join(" ", ["print:hidden"])], (elems_12 = [createElement(TableContainer, (Title_6 = t("receivers.visible_for"), {
                            Content: createElement(VisibleUserSection, {
                                CustomerConfiguration: props.CustomerConfiguration,
                                PropertyConfigurations: props.PropertyConfigurations,
                                Users: props.ToolBox.VisibleUsers,
                            }),
                            Title: unwrap(Title_6),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))) : (empty())))))))))))), delay(() => {
                            let matchValue_10, elems_13, Title_7;
                            return append((matchValue_10 = props.ToolBox.Receiver.ReceiverType, (matchValue_10.tag === 5) ? (empty()) : ((matchValue_10.tag === 4) ? (empty()) : ((matchValue_10.tag === 9) ? (empty()) : ((matchValue_10.tag === 6) ? (empty()) : ((matchValue_10.tag === 8) ? (empty()) : ((matchValue_10.tag === 7) ? (empty()) : ((matchValue_10.tag === 3) ? (empty()) : ((matchValue_10.tag === 1) ? (empty()) : ((matchValue_10.tag === 2) ? (empty()) : ((matchValue_10.tag === 10) ? (empty()) : singleton_1(reactElement("section", createObj(ofArray([["id", "visible-receiver-section-id"], ["className", join(" ", ["print:hidden"])], (elems_13 = [createElement(TableContainer, (Title_7 = t("general.visible_receiver"), {
                                Content: createElement(VisibleReceiverSection, {
                                    Dispatch: props.Dispatch,
                                    ToolBox: props.ToolBox,
                                    UserData: props.UserData,
                                }),
                                Title: unwrap(Title_7),
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))))))))))))), delay(() => {
                                let elems_14, Title_8;
                                return append((!(props.UserData.Role === "user") && !equals(props.ToolBox.Receiver.ReceiverType, new ReceiverTypeName(10, []))) ? singleton_1(reactElement("section", createObj(ofArray([["id", "barcodes-section-id"], (elems_14 = [createElement(TableContainer, (Title_8 = t("general.qr_code"), {
                                    Content: createElement(BarcodeSection, {
                                        Dispatch: props.Dispatch,
                                        QRCodeIds: props.ToolBox.Receiver.QRCodeIds,
                                        UserData: props.UserData,
                                    }),
                                    Title: unwrap(Title_8),
                                }))], ["children", reactApi.Children.toArray(Array.from(elems_14))])])))) : empty(), delay(() => {
                                    let elems_15, Title_9;
                                    return !(props.UserData.Role === "user") ? singleton_1(reactElement("section", createObj(ofArray([["id", "history-section-id"], ["className", join(" ", ["print:hidden"])], (elems_15 = [createElement(TableContainer, (Title_9 = t("general.history"), {
                                        Content: createElement(HistorySection, {
                                            HistoryRows: props.HistoryRows,
                                            PropertyConfigurations: props.PropertyConfigurations,
                                            State: props.State,
                                            ToolBox: props.ToolBox,
                                        }),
                                        Title: unwrap(Title_9),
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))) : empty();
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_16))])])))], ["children", reactApi.Children.toArray(Array.from(elems_17))])])));
}

export function ToolBoxView(props) {
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setWhoHasWhatDetailTourDismissed = patternInput_1[1];
    const patternInput_2 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initToolBox(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.UserId, props.UserData], undefined);
    const state_1 = patternInput_2[0];
    const clearWhoHasWhatTourFromUrl = () => {
        RouterModule_nav(ofArray(["receivers", props.UserId + RouterModule_encodeQueryString(withoutOnboardingTourQueryParams())]), 1, 1);
    };
    const matchValue = state_1.ToolBox;
    const matchValue_1 = state_1.Locations;
    const matchValue_2 = state_1.PropertyConfigurations;
    const matchValue_3 = state_1.CustomerConfiguration;
    const matchValue_4 = state_1.Reservations;
    const matchValue_5 = state_1.Documents;
    const matchValue_6 = state_1.AccountSettings;
    let matchResult, accountSettings, customerConfiguration, documents, locations, propertyConfigurations, reservations, toolBox, toolRows;
    if (matchValue == null) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_6.fields[0];
        customerConfiguration = matchValue_3.fields[0];
        documents = matchValue_5.fields[0];
        locations = matchValue_1.fields[0];
        propertyConfigurations = matchValue_2.fields[0];
        reservations = matchValue_4.fields[0];
        toolBox = matchValue[0];
        toolRows = matchValue[1];
    }
    switch (matchResult) {
        case 0: {
            const xs_4 = toList(delay(() => append(singleton_1(createElement(ToolBoxDetails, {
                AccountSettings: accountSettings,
                ConsumableHistoryRows: state_1.ConsumableHistoryRows,
                CustomerConfiguration: customerConfiguration,
                Dispatch: patternInput_2[1],
                Documents: documents,
                HistoryRows: state_1.HistoryRows,
                Locations: locations,
                OnBack: () => {
                    const xs = ofArray(props.OnBackPath);
                    const queryString_1 = getQueryParams(undefined);
                    defaultArgWith(map_1((tupledArg_1) => {
                        RouterModule_nav(append_1(tupledArg_1[0], singleton(tupledArg_1[1] + RouterModule_encodeQueryString(queryString_1))), 1, 1);
                    }, RouterModule_trySeparateLast(xs)), () => {
                        RouterModule_nav(singleton(RouterModule_encodeQueryString(queryString_1)), 1, 1);
                    });
                },
                OnEdit: () => {
                    const matchValue_8 = props.OnEditPath;
                    if (matchValue_8 == null) {
                        RouterModule_nav(ofArray(["receivers", Helper_receiverTypeNameToString(toolBox.Receiver.ReceiverType), toolBox.Receiver.Id, "edit" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
                    }
                    else {
                        RouterModule_nav(ofArray(matchValue_8), 1, 1);
                    }
                },
                PropertyConfigurations: propertyConfigurations,
                Reservations: reservations,
                State: state_1,
                ToolBox: toolBox,
                ToolRows: toolRows,
                UserData: state_1.UserData,
            })), delay(() => {
                let Steps;
                return (isWhoHasWhatOnboardingReceiverDetailPhase() && !patternInput_1[0]) ? singleton_1(createElement(TourGuide, (Steps = singleton(new TourStep("[data-test-id=\'toolbox-detail-inventory-table-heading\']", t("onboarding.tour.who_has_what_assigned_title"), reactElement("div", {
                    children: t("onboarding.tour.who_has_what_assigned_content"),
                }), "bottom", false)), {
                    IsRunning: true,
                    Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                    OnFinish: () => {
                        setWhoHasWhatDetailTourDismissed(true);
                        clearWhoHasWhatTourFromUrl();
                    },
                    OnSkip: () => {
                        setWhoHasWhatDetailTourDismissed(true);
                        clearWhoHasWhatTourFromUrl();
                    },
                    ScrollFirstStep: true,
                    Steps: Steps,
                }))) : empty();
            }))));
            return react.createElement(react.Fragment, {}, ...xs_4);
        }
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

